import { Calculator, Home, Car, TrendingUp, TrendingDown, Search, DollarSign } from 'lucide-react';

export const toolsConfig = {
  'real-estate': {
    name: 'Real Estate',
    description: 'Investment analysis and property tools',
    icon: Home,
    color: 'bg-green-500',
    tools: {
      'fix-flip-roi': {
        name: 'Fix & Flip ROI Calculator',
        description: 'Calculate return on investment for fix and flip properties',
        icon: TrendingUp,
        component: 'FixFlipROI'
      },
      'buy-vs-rent': {
        name: 'Buy vs Rent Calculator',
        description: 'Compare the costs of buying versus renting',
        icon: Calculator,
        component: 'BuyVsRent'
      },
      'deal-finder': {
        name: 'Deal Finder',
        description: 'Find profitable real estate deals from multiple sources',
        icon: Search,
        component: 'DealFinder'
      },
      'brrr-calculator': {
        name: 'BRRR Calculator',
        description: 'Model the full BRRR cycle with NOI, cap value, loan proceeds, and DSCR',
        icon: TrendingUp,
        component: 'BRRRCalculator'
      },
      'mortgage-amortization': {
        name: 'Mortgage Amortization Calculator',
        description: 'Build detailed mortgage payoff schedules with extra payments',
        icon: Calculator,
        component: 'MortgageAmortizationCalculator'
      }
    }
  },
  'cars': {
    name: 'Cars',
    description: 'Automotive financial calculators and tools',
    icon: Car,
    color: 'bg-blue-500',
    tools: {
      'finance-analyzer': {
        name: 'Finance Analyzer',
        description: 'Build auto loan scenarios and forecast equity',
        icon: DollarSign,
        component: 'FinanceAnalyzer'
      },
      'lease-analyzer': {
        name: 'Lease Analyzer',
        description: 'Analyze car lease deals and money factor calculations',
        icon: Calculator,
        component: 'LeaseAnalyzer'
      },
      'depreciation-calculator': {
        name: 'Depreciation Calculator',
        description: 'Calculate vehicle depreciation over time',
        icon: TrendingDown,
        component: 'DepreciationCalculator'
      }
    }
  },
  'finance': {
    name: 'Finance',
    description: 'General financial planning and analysis tools',
    icon: DollarSign,
    color: 'bg-purple-500',
    tools: {
      'compound-interest': {
        name: 'Compound Interest Calculator',
        description: 'Calculate compound interest and investment growth',
        icon: TrendingUp,
        component: 'CompoundInterest'
      },
      'salary-calculator': {
        name: 'Salary Calculator',
        description: 'Convert pay between hourly, daily, weekly, and annual amounts',
        icon: Calculator,
        component: 'SalaryCalculator'
      },
      'loan-amortization': {
        name: 'Loan Amortization Schedule Calculator',
        description: 'Generate loan payoff schedules and analyze interest savings',
        icon: Calculator,
        component: 'LoanAmortizationCalculator'
      }
    }
  }
};
